import { createFileRoute } from '@tanstack/react-router';

import { OauthConsentScreen } from '../../features/auth/OauthConsentScreen';

/** شاشة الموافقة محمية بـ`AuthGuard` من الجذر؛ بلا جلسة تعود للدخول ثم لنفس الرابط. */
export const Route = createFileRoute('/oauth/consent')({ component: OauthConsentScreen });
